import {AxiosResponse} from "axios";
import {$api} from "../api/api.ts";
import {getToken} from "../../utils/Utils.ts";
import {ICreatePublicationParams, ISInglePublicationsResponseData} from "../models/SinglePublicationsResponse.ts";
import {PublicationStatus} from "../../constants/enums.ts";


export const PublicationService = {
    fetchPublications(id: string): Promise<AxiosResponse<ISInglePublicationsResponseData[]>> {
        return $api.get(`/single_publications`, {
            params: {channel_id: id},
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    fetchPublicationData(id: string): Promise<AxiosResponse<ISInglePublicationsResponseData>> {
        return $api.get(`/single_publications/${id}`, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    updatePublication(id: string,  params:{status: PublicationStatus}): Promise<AxiosResponse<ISInglePublicationsResponseData>> {
        return $api.patch(`/single_publications/${id}`, params,{
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    createPublication(params: ICreatePublicationParams): Promise<AxiosResponse<ISInglePublicationsResponseData>> {
        return $api.post(`/single_publications`, params, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
}
